/**
 *本地存储对象key
 *@author caijing
 *@date 2022/3/2 14:03
 */
export class LocalStorageKey {
  public static user = 'developUser';

  public static token = 'token';
}
